// Applies the theme to <html data-theme> synchronously whenever the UI store changes, so
// anything that reads CSS variables during render (charts) sees the new values.
import { useUi, type Theme } from '../stores/ui';

function apply(theme: Theme) {
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme = theme;
}

export function installTheme(): void {
  apply(useUi.getState().theme);
  useUi.subscribe((s, prev) => {
    if (s.theme !== prev.theme) apply(s.theme);
  });
}
